import {
  SET_IEC_DATA,
  ADD_IEC_DATA,
  ADD_IEC_DATA_SUCCESS,
  ADD_IEC_DATA_FAILURE,
  UPDATE_IEC_DATA,
  UPDATE_IEC_DATA_SUCCESS,
  UPDATE_IEC_DATA_FAILURE,
  CLEAR_SELECTED_ITEMS,
  SELECT_IEC_ITEMS,
} from "./IECModuleAction";
const initialState = {
  IECdata: [],
  data: [],
  selectedItems: [],
};

const IECModuleReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_IEC_DATA:
      return {
        ...state,
        IECdata: action.payload,
      };
    case ADD_IEC_DATA:
      return { ...state, isLoading: true };
    case ADD_IEC_DATA_SUCCESS:
      return { ...state, isLoading: false, data: action.payload };
    case ADD_IEC_DATA_FAILURE:
      return { ...state, isLoading: false };
    case UPDATE_IEC_DATA:
      return { ...state, isLoading: true };
    case UPDATE_IEC_DATA_SUCCESS:
      return { ...state, isLoading: false };
    case UPDATE_IEC_DATA_FAILURE:
      return { ...state, isLoading: false };
    case CLEAR_SELECTED_ITEMS:
      return {
        ...state,
        selectedItems: [],
      };
    case SELECT_IEC_ITEMS:
      return {
        ...state,
        selectedItems: action.payload,
      };

    default:
      return state;
  }
};

export default IECModuleReducer;
